import { useAuth0 as useAuth0SDK } from '@auth0/auth0-react'

/**
 * Custom hook that wraps Auth0 SDK hook with app-specific logic
 * Provides authentication state and methods for login/logout
 */
export function useAuth0() {
  const auth0 = useAuth0SDK()

  return {
    // State
    isAuthenticated: auth0.isAuthenticated,
    isLoading: auth0.isLoading,
    user: auth0.user,
    error: auth0.error,

    // Methods
    loginWithRedirect: auth0.loginWithRedirect,
    logout: () =>
      auth0.logout({
        logoutParams: {
          returnTo: window.location.origin,
        },
      }),
    getAccessTokenSilently: auth0.getAccessTokenSilently,
  }
}
